import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@arnsbogroup/react-voicearchive'
import TeamUserCard from './../TeamUserCard'
import TeamCard from './../TeamCard'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";
import Form from "../../../SupplierSignUp/components/Form";

const Teams = ({ editable = false, customers, users }) => {
  const { formatMessage } = useIntl()
  return (
    <React.Fragment>
      <div className="pb-5 border-b border-gray-200 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            <FormattedMessage {...messages.title} />
          </h3>

          <p className="mt-2 max-w-4xl text-sm text-gray-500">
            <FormattedMessage {...messages.subtitle} />
          </p>
        </div>
        <div className="mt-4 flex md:mt-0 md:ml-4">
          <Link to="/company/team/invite">
            <Button disabled={!editable} title={formatMessage(messages.invite)}>
              <FormattedMessage {...messages.invite}/>
            </Button>
          </Link>
        </div>
      </div>
      <div className="w-full mt-6 mb-3">
        <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">
          <FormattedMessage {...messages.branches}/>
        </h2>
      </div>

      <ul className="grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
        { customers.map(({ uid, name, contacts }) => (
          <TeamCard key={uid} name={name} members={contacts} id={uid} />
        )) }
      </ul>

      <div className="w-full mt-12 mb-3">
        <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">
          <FormattedMessage {...messages.contacts}/>
        </h2>
      </div>

      <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        { users.map((props) => (
          <TeamUserCard key={props.uid} {...props} on/>
        )) }
      </ul>
    </React.Fragment>
  )
}

export default Teams
